import {createTheme} from "@material-ui/core";


export const theme = createTheme({
    palette: {
        primary:  {main: '#80ED99'},
        secondary: {main: '#C7F9CC'}
    }
});

export const errorTheme = createTheme({
    palette: {
        primary: {main: '#d32f2f'},
        secondary: {main: '#ef5350'}
    }
});


export const themePartners = createTheme({
    palette: {
        primary:  {main: '#fd8379'},
        secondary: {main: '#f8aea9'}
    }
});
